var map = {
	"./amazonCard.png": 59302,
	"./bgGradient.jpg": 13125,
	"./bielefeld_b.svg": 91315,
	"./cinch.png": 21673,
	"./eq5d5l.jpg": 69590,
	"./hero.png": 70928,
	"./iconSvgs": 25015,
	"./iconSvgs.json": 25015,
	"./oh-logo.png": 59773,
	"./ohe.jpg": 41392,
	"./uos.png": 70709,
	"./uos_w.png": 6459,
	"./uos_w.svg": 99735,
	"./welcome.png": 73738,
	"./wellcome_w.png": 90026,
	"./wits.jpg": 62507,
	"./wits.svg": 38625
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;